export default "__VITE_ASSET__uxGEu9VC__"